import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { RequestOption } from '../request-card-selection/request-card-selection.component';

@Component({
  selector: 'formly-card-type',
  template: `
    <app-request-card-selection
      [options]="cardOptions"
      [label]="cardLabel"
      [required]="cardRequired"
      [formControl]="control"
      [cssClass]="props['itemCssClass']"
      [labelBold]="props['labelBold'] ?? true">
    </app-request-card-selection>
  `,
  standalone: false
})
export class FormlyCardTypeComponent extends FieldType {
  get cardOptions(): RequestOption[] {
    return (this.to.options as RequestOption[]) || [];
  }

  get cardLabel(): string {
    return this.to.label || '';
  }

  get cardRequired(): boolean {
    return this.to.required || false;
  }

  get control(): FormControl {
    return this.formControl as FormControl;
  }
}